module.exports = __webpack_public_path__ + "media/images/help/schedule_weekly-ed4a482ad22d043e65811f0396330eb3.png";